<template>
  <div>
    <div class="display-flex">
      <input
        type="checkbox"
        class="regular-checkbox"
        v-bind:value="value"
        :input="value ? handleInput : handleInput"
        @input="handleInput"
        ref="input"
        :disabled="disabled || readonly"
        :style="checkDisable"
      />
      <span
        @click="handleInputFromLabel"
        :class="value ? 'labelClass-checked' : 'labelClass'"
        >{{ label }}</span
      >
    </div>
    <span class="error-text">{{ error }}</span>
  </div>
</template>

<script>
export default {
  name: "SCheckBox",

  components: {},

  data() {
    return {};
  },

  methods: {
    handleInput: function (event) {
      this.$emit("input", this.$refs.input.checked);
      //   this.value = event.target.checked;
    },
    handleInputFromLabel() {
      if (this.readonly || this.disabled) {
        return;
      }
      this.$refs.input.checked = !this.$refs.input.checked;
      this.$emit("input", this.$refs.input.checked);
    },
  },

  mounted() {
    this.$refs.input.checked = this.value;
  },

  validations: function () {
    return {};
  },
  props: {
    label: String,
    error: String,
    disabled: Boolean,
    readonly: Boolean,
    type: {
      default: "checkbox",
    },
    icon: String,
    border: { type: Boolean, default: true },
    value: {},
  },

  computed: {
    checkDisable() {
      if (this.disabled) {
        return {
          cursor: "not-allowed",
        };
      } else {
        return null;
      }
    },
  },
  watch: {
    value(event) {
      // console.log(this.label,event);
      this.$refs.input.checked = event;
    },
  },
};
</script>

<style lang="scss" scoped>
.error-text {
  //   position: absolute;
  display: block;
    font-family: "Roboto !important";
  font-size: 6px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: var(--text-error-color);
  padding-left: 32px;
  margin-top: -7px;
}
.display-flex {
  display: flex;
  // padding: 2%;
}
.labelClass {
  // margin-top: 2px;
  margin-left: 14px;
    font-family: "Roboto !important";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #272727;
  cursor: pointer;
  align-self: center;
}

.labelClass-checked {
  // margin-top: 2px;
  margin-left: 14px;
    font-family: "Roboto !important";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #272727;
  cursor: pointer;
  align-self: center;
}
input[type="checkbox"] {
  appearance: none;
  margin: 1px;
  padding: 9px;
}
.regular-checkbox {
  -webkit-appearance: none;
  // background-color: #fafafa;
  border: solid 1px var(--brown-grey);
  // box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05);
  padding: 9px;
  // border-radius: 3px;
  display: inline-block;
  position: relative;
  width: 16px !important;
  height: 16px !important;
}
.regular-checkbox:active,
.regular-checkbox:checked:active {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px 1px 3px rgba(0, 0, 0, 0.1);
}

.regular-checkbox:checked {
  // background-color: #e9ecee;
  border: 1px solid #000000;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05),
    inset 15px 10px -12px rgba(255, 255, 255, 0.1);
  // color: #99a1a7;
}
.regular-checkbox:hover {
  // background-color: #e9ecee;
  border: 1px solid #434343;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05),
    inset 15px 10px -12px rgba(255, 255, 255, 0.1);
  // color: #99a1a7;
}
.regular-checkbox:checked:after {
  // content: "\2714";
  content: url(../assets/Tick.png);
  font-size: 14px;
  position: absolute;
  top: -17px;
  left: -16px;
  transform: scale(0.5);
}
.regular-radio {
  -webkit-appearance: none;
  background-color: #fafafa;
  border: 1px solid #cacece;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 9px;
  border-radius: 50px;
  display: inline-block;
  position: relative;
}

.regular-radio:checked:after {
  content: " ";
  width: 12px;
  height: 12px;
  border-radius: 50px;
  position: absolute;
  top: 3px;
  background: #99a1a7;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.3);
  text-shadow: 0px;
  left: 3px;
  font-size: 32px;
}

.regular-radio:checked {
  background-color: #e9ecee;
  color: #99a1a7;
  border: 1px solid #adb8c0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05),
    inset 15px 10px -12px rgba(255, 255, 255, 0.1),
    inset 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.regular-radio:active,
.regular-radio:checked:active {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px 1px 3px rgba(0, 0, 0, 0.1);
}
</style>